// TODO: 추후에 기존 repository 접근을 이쪽으로 변경할 예정입니다.
import { container } from "tsyringe";

// entities
import { UserRepository } from "@/entities/user/models/repository";
import { ChallengeTemplateRepository } from "@/entities/challenge-template/domain/repository";
import { ChallengeRepository } from "@/entities/challenge/domain/repository";
import { ProblemRepository } from "@/entities/problem/domain/repository";
import { AssignedCurriculumProblemRepository } from "@/entities/assigned-curriculum-problem/domain/repository";
import { ConceptEnhancementRepository } from "@/entities/concept-enhancement/domain/repository";
import { ClassRepository } from "@/entities/class/domain/repository";
import { SchoolRepository } from "@/entities/school/domain/repository";
import { LocationRepository } from "@/entities/location/domain/repository";
import { CurriculumRepository } from "@/entities/curriculum/domain/repository";
import { AcademyRepository } from "@/entities/academy/domain/repository";
import { AcademyRegistrationRequestRepository } from "@/entities/academy-registration-request/domain/repository";
import type { CommonAccountsRepository } from "@/entities/common/interface/common-accounts/domain/repository";
import { StudyRepository } from "@/entities/study/models/repository";
import { CurriculumMetadataRepository } from "@/entities/curriculum-metadata/domain/repository";
import { SemesterRepository } from "@/entities/semester/domain/repository";
import { SubmittedProblemRepository } from "@/entities/submitted-problems/domain/repository";
import { StudentChallengeRepository } from "@/entities/student-challenge/domain/repository";
import { StudentGroupRepository } from "@/entities/student-group/domain/repository";
import { AiTutorSessionRepository } from "@/entities/ai-tutor-session/domain/repository";
import { PingRepository } from "@/entities/ping/domain/repository";

// infrastructure
import UserRepositoryImpl from "@/entities/user/infrastructure/repository";
import ChallengeTemplateRepositoryImpl from "@/entities/challenge-template/infrastructure/repository";
import ChallengeRepositoryImpl from "@/entities/challenge/infrastructure/repository";
import ProblemRepositoryImpl from "@/entities/problem/infrastructure/repository";
import AssignedCurriculumProblemRepositoryImpl from "@/entities/assigned-curriculum-problem/infrastructure/repository";
import ConceptEnhancementRepositoryImpl from "@/entities/concept-enhancement/infrastructure/repository";
import ClassRepositoryImpl from "@/entities/class/infrastructure/repository";
import SchoolRepositoryImpl from "@/entities/school/infrastructure/repository";
import LocationRepositoryImpl from "@/entities/location/infrastructure/repository";
import CurriculumRepositoryImpl from "@/entities/curriculum/infrastructure/repository";
import AcademyRepositoryImpl from "@/entities/academy/infrastructure/repository";
import AcademyRegistrationRequestRepositoryImpl from "@/entities/academy-registration-request/infrastructure/repository";
import CommonAccountsRepositoryImpl from "@/entities/common/interface/common-accounts/infrastructure/repository";
import StudyRepositoryImpl from "@/entities/study/infrastructure/repository";
import CurriculumMetadataRepositoryImpl from "@/entities/curriculum-metadata/infrastructure/repository";
import SemesterRepositoryImpl from "@/entities/semester/infrastructure/repository";
import SubmittedProblemRepositoryImpl from "@/entities/submitted-problems/infrastructure/repository";
import StudentChallengesRepositoryImpl from "@/entities/student-challenge/infrastructure/repository";
import StudentGroupRepositoryImpl from "@/entities/student-group/infrastructure/repository";
import AiTutorSessionRepositoryImpl from "@/entities/ai-tutor-session/infrastructure/repository";
import PingRepositoryImpl from "@/entities/ping/infrastructure/repository";

const repositoriesRegisterInit = () => {
    // domain
    container.register<UserRepository>("UserRepository", {
        useClass: UserRepositoryImpl,
    });
    container.register<ChallengeTemplateRepository>("ChallengeTemplateRepository", {
        useClass: ChallengeTemplateRepositoryImpl,
    });
    container.register<ChallengeRepository>("ChallengeRepository", {
        useClass: ChallengeRepositoryImpl,
    });
    container.register<ProblemRepository>("ProblemRepository", {
        useClass: ProblemRepositoryImpl,
    });
    container.register<AssignedCurriculumProblemRepository>("AssignedCurriculumProblemRepository", {
        useClass: AssignedCurriculumProblemRepositoryImpl,
    });
    container.register<ConceptEnhancementRepository>("ConceptEnhancementRepository", {
        useClass: ConceptEnhancementRepositoryImpl,
    });
    container.register<ClassRepository>("ClassRepository", {
        useClass: ClassRepositoryImpl,
    });
    container.register<SchoolRepository>("SchoolRepository", {
        useClass: SchoolRepositoryImpl,
    });
    container.register<LocationRepository>("LocationRepository", {
        useClass: LocationRepositoryImpl,
    });
    container.register<CurriculumRepository>("CurriculumRepository", {
        useClass: CurriculumRepositoryImpl,
    });
    container.register<AcademyRepository>("AcademyRepository", {
        useClass: AcademyRepositoryImpl,
    });
    container.register<AcademyRegistrationRequestRepository>(
        "AcademyRegistrationRequestRepository",
        {
            useClass: AcademyRegistrationRequestRepositoryImpl,
        },
    );
    container.register<CommonAccountsRepository>("CommonAccountsRepository", {
        useClass: CommonAccountsRepositoryImpl,
    });
    container.register<StudyRepository>("StudyRepository", {
        useClass: StudyRepositoryImpl,
    });
    container.register<CurriculumMetadataRepository>("CurriculumMetadataRepository", {
        useClass: CurriculumMetadataRepositoryImpl,
    });
    container.register<SemesterRepository>("SemesterRepository", {
        useClass: SemesterRepositoryImpl,
    });
    container.register<SubmittedProblemRepository>("SubmittedProblemRepository", {
        useClass: SubmittedProblemRepositoryImpl,
    });
    container.register<StudentChallengeRepository>("StudentChallengeRepository", {
        useClass: StudentChallengesRepositoryImpl,
    });
    container.register<StudentGroupRepository>("StudentGroupRepository", {
        useClass: StudentGroupRepositoryImpl,
    });
    container.register<AiTutorSessionRepository>("AiTutorSessionRepository", {
        useClass: AiTutorSessionRepositoryImpl,
    });
    container.register<PingRepository>("PingRepository", {
        useClass: PingRepositoryImpl,
    });
};

export default repositoriesRegisterInit;
